import React from "react";
import { Link } from "react-router-dom";
import { IconImage, TrackEvent } from "./utils";

export function FeaturedHelpTopics(props) {

  // get limit from props with fallback to total number of featured articles
  const limit = props?.limit || props.data.articles.filter((item) => item.featured).length;

  return (
    <div className={`contact-featured ${props.type ? 'contact-featured--' + props.type : ''}`}>
      {props.title && <h6 className="font-sans-serif">{props.title}</h6>}
      <ul className="contact-featured__items">
        <FeaturedHelpItems data={props.data} limit={limit} />
      </ul>
    </div>
  );
}

function FeaturedHelpItems(props) {  

  return (
    <>
      {props.data.articles
        .filter((item) => item.featured)        
        .sort((a, b) => a.featuredOrder - b.featuredOrder)
        .slice(0, props.limit)
        .map((filteredArticle, i) => (
          <li key={i}>
            <Link
              to={`/resource-centre/${filteredArticle.categorySlug}/${filteredArticle.slug}`}
              tabIndex={0}
              onClick={() => TrackEvent('card',
                { 'context': filteredArticle.subCategory ? filteredArticle.title + ' - ' + filteredArticle.subCategory : filteredArticle.title }
              )}
            >
              <span>{i + 1}</span>
              <div className="contact-featured__icon">
                <IconImage img={filteredArticle.iconPath || filteredArticle.categoryIconPath}></IconImage>
              </div>
              <div className="contact-featured__title">
                <p>{filteredArticle.title}</p>
                {filteredArticle.subCategory &&
                  <small>{filteredArticle.subCategory}</small>
                }
              </div>
            </Link>
          </li>
        ))}
    </>
  );
}
